import { Component, inject } from "@angular/core";
import { Location } from "@angular/common";
import { TranslatePipe } from "@ngx-translate/core";
import { LangService } from "@otimo/report-base";
import { AppSettings, APP_SETTINGS } from "@root/app.settings";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { faCaretRight, faLanguage } from "@fortawesome/free-solid-svg-icons";


@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    imports: [TranslatePipe, NgbDropdownModule, FaIconComponent]
})
export class HeaderComponent {
    private readonly env = inject<AppSettings>(APP_SETTINGS);
    private readonly lang = inject<LangService>(LangService);
    private readonly location = inject<Location>(Location);

    faLanguage = faLanguage;
    faCaretRight = faCaretRight;

    public goToMyReports(): void {
        const currentLang = LangService.currentLang.getValue();
        window.location.href = this.env.getUserReportUrl(currentLang);
    }

    public changeLanguage(language: string) {
        let path = this.location.path();
        const lang = path.split("/")[1];
        if (lang.length == 2)
            path = path.substr(3);
        const modifiedPath = "/" + language + path;

        this.location.go(modifiedPath);
        this.lang.changeLanguage(language);
    }

}
